// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2aa030e3","605":"9ac34df8","809":"62452d41","981":"0ac4477a"}[chunkId] + ".chunk.js";
};